export function defaultEtrnVehicleType() {
  return "";
}

export function edoVehicleOwnershipTypeLabel(value) {
  const labels = {
    1: "Собственное",
    3: "Аренда",
    4: "Лизинг",
    5: "Безвозмездное пользование",
  };

  return labels[String(value)] || value || "";
}

export function ownershipBasisRequired(ownershipType) {
  return ["3", "4", "5"].includes(String(ownershipType || ""));
}

export function etrnVehicleTypeFromVehicle(prefix, vehicle = {}) {
  return (
    vehicle.edo_vehicle_type ||
    vehicle.consignment_note_vehicle_type ||
    vehicle.etrn_vehicle_type ||
    ""
  );
}

export function edoVehiclePayload(form, prefix, extraFields = {}) {
  const etrnVehicleType = form[`${prefix}EtrnVehicleType`];
  const ownershipDocument = ownershipDocumentPayload(form, prefix);
  const normalizedExtraFields = { ...extraFields };
  delete normalizedExtraFields.ownershipDocumentAuthor;

  return {
    registration_number: form[`${prefix}RegistrationNumber`],
    model: form[`${prefix}Model`],
    vehicle_type: form[`${prefix}VehicleType`],
    edo_vehicle_type: etrnVehicleType,
    etrn_vehicle_type: etrnVehicleType,
    consignment_note_vehicle_type: etrnVehicleType,
    vin: form[`${prefix}Vin`],
    sts_number: form[`${prefix}StsNumber`],
    ownership_type: form[`${prefix}OwnershipType`],
    ...(ownershipDocument ? { ownership_document: ownershipDocument } : {}),
    ...normalizedExtraFields,
  };
}

export function ownershipDocumentPayload(form, prefix) {
  const authorInn = form[`${prefix}OwnershipDocumentAuthorInn`];
  const document = {
    name: form[`${prefix}OwnershipDocumentName`],
    number: form[`${prefix}OwnershipDocumentNumber`],
    date: form[`${prefix}OwnershipDocumentDate`],
    ...(authorInn ? { author: { inn: authorInn } } : {}),
  };

  return Object.values(document).some(Boolean) ? document : null;
}

export function hasEdoVehicleData(form, prefix) {
  return [
    `${prefix}Id`,
    `${prefix}RegistrationNumber`,
    `${prefix}Model`,
    `${prefix}VehicleType`,
    `${prefix}EtrnVehicleType`,
    `${prefix}Vin`,
    `${prefix}StsNumber`,
    `${prefix}OwnershipType`,
    `${prefix}CapacityTons`,
    `${prefix}VolumeM3`,
    `${prefix}BodyType`,
    `${prefix}CountryCode`,
    `${prefix}OwnershipDocumentName`,
    `${prefix}OwnershipDocumentNumber`,
    `${prefix}OwnershipDocumentDate`,
    `${prefix}OwnershipDocumentAuthorId`,
    `${prefix}OwnershipDocumentAuthorInn`,
  ].some((key) => String(form[key] ?? "").trim().length > 0);
}
